import { render, staticRenderFns } from "./RevOrganosTable.vue?vue&type=template&id=63e4edc2"
import script from "./RevOrganosTable.vue?vue&type=script&lang=js"
export * from "./RevOrganosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports